import { SuccessImage } from 'components/images';
import { AnimatedDialogImageWrapper, Stack, Text } from 'components/ui';
import { FC } from 'react';

export interface SendBroadcastSuccessStepProps {}

export const SendBroadcastSuccessStep: FC<
  SendBroadcastSuccessStepProps
> = () => (
  <Stack space={4}>
    <AnimatedDialogImageWrapper>
      <SuccessImage />
    </AnimatedDialogImageWrapper>
    <Text fontSize={4} textAlign='center'>
      Your broadcast has been sent.
    </Text>
  </Stack>
);
